import classNames from 'classnames';
import { sortBy } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import QRCode from '../icons/QRCode';
import LiveGameCard from '../partials/LiveGameCard';

import styles from '../../../styles/steps/games.module.scss';

const propTypes = {
    games: PropTypes.arrayOf(PropTypes.shape({})),
    isDisplay: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    games: null,
    isDisplay: false,
    className: null,
};

function Games({ games, isDisplay, className }) {
    const { name: theme = null } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const finalGames = useMemo(() => sortBy((games || []).slice(0, 6), 'id'), [games]);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                { [styles.isDisplay]: isDisplay, [className]: className !== null },
            ])}
        >
            <div className={styles.inner}>
                <h3 className={styles.title}>
                    {finalGames !== null && finalGames.length > 0 ? (
                        <FormattedMessage
                            defaultMessage="Upcoming games"
                            description="Step title"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="No games available today! Check back tomorrow."
                            description="Step title"
                        />
                    )}
                </h3>
                <div className={styles.games}>
                    {(finalGames || []).map((game) => (
                        <LiveGameCard
                            key={game.id}
                            className={styles.card}
                            timeClassName={styles.time}
                            game={game}
                            disabled
                        />
                    ))}
                </div>
                <div className={styles.qrcodeContainer}>
                    <p className={styles.description}>
                        <FormattedMessage
                            defaultMessage="Scan the QR code to enter."
                            description="Display message"
                        />
                    </p>
                    <QRCode className={styles.qrcode} component={theme} />
                </div>
            </div>
        </div>
    );
}

Games.propTypes = propTypes;
Games.defaultProps = defaultProps;

export default Games;
